import React from "react";
import { FiArchive, FiEye, FiMoreVertical } from "react-icons/fi";
import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	UncontrolledDropdown
} from "reactstrap";
import { archivableContractStatuses } from "types/contractStatus";

export default function ContractRowActionsMenu({
	contract,
	onArquivar,
	onDesarquivar
}) {
	const canArchive =
		!contract.archived && archivableContractStatuses.includes(contract.status);
	const canUnarchive = !!contract.archived;

	return (
		<UncontrolledDropdown>
			<DropdownToggle
				tag="span"
				data-testid="contract-row-actions-toggle"
				style={{ cursor: "pointer" }}
			>
				<FiMoreVertical />
			</DropdownToggle>
			<DropdownMenu right container="body">
				<DropdownItem
					onClick={() => {
						let win = window.open(`/contracts/${contract._id}`, "_blank");
						win.focus();
					}}
				>
					<FiEye className="mr-2" />
					Detalhes
				</DropdownItem>
				{canArchive && (
					<DropdownItem
						style={{ backgroundColor: "#fff4e5", color: "#e8590c" }}
						onClick={() => onArquivar(contract)}
					>
						<FiArchive className="mr-2" />
						Arquivar
					</DropdownItem>
				)}
				{canUnarchive && (
					<DropdownItem
						style={{ backgroundColor: "#fff4e5", color: "#e8590c" }}
						onClick={() => onDesarquivar(contract)}
					>
						<FiArchive className="mr-2" />
						Desarquivar
					</DropdownItem>
				)}
			</DropdownMenu>
		</UncontrolledDropdown>
	);
}
